import * as Icon from 'react-bootstrap-icons'

function P_Home() {
  document.title = 'Home | iamcatraz'
  return (
    <center>
      <div
        className='card text-white d-flex'
        style={{
          width: '80vw',
          marginTop: '5vh',
          backgroundColor: 'transparent',
          backdropFilter: 'blur(10px)',
          border: 'none',
        }}>
        <div className='row g-0'>
          <div className='col-md-4'>
            <img
              src={`${process.env.PUBLIC_URL}/ProfilePicturePeachTransparent.png`}
              className='img-fluid'
              alt=''
            />
          </div>
          <div className='col-md-8'>
            <div className='card-body'>
              <h5 className='card-title'>Welcome to my Portfolio!</h5>
              <p className='card-text pb-5'>
                First of all, thanks for visiting my personal website. I am an aspiring freelance
                ReactJS developer focussed on small projects for businesses and individuals that are
                in need of a website. <br /> Below are my socials and reviews of my work! <br />
                Feel free to have a look around! <br /> Thanks, <br />
                Harry (iamcatraz)
              </p>
              <p className='card-text d-flex'>
                <a
                  className='nav-link active mx-auto'
                  aria-current='page'
                  aria-label='Email button for iamcatraz'
                  href='mailto:harrycatraz@gmail.com'>
                  <Icon.Envelope size={20} />
                </a>
                <a
                  className='nav-link active mx-auto'
                  aria-current='page'
                  aria-label='Github button for iamcatraz'
                  href='https://www.github.com/HarryCatraz'>
                  <Icon.Github size={20} />
                </a>
                <a
                  className='nav-link active mx-auto'
                  aria-current='page'
                  aria-label='Youtube button for iamcatraz'
                  href='https://www.youtube.com/HarryCatraz'>
                  <Icon.Youtube size={20} />
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        className='card text-white d-flex'
        style={{
          width: '40vw',
          marginTop: '2vh',
          paddingBottom: '10vh',
          backgroundColor: 'transparent',
          backdropFilter: 'blur(10px)',
          border: 'none',
        }}>
        <div id='carouselExampleCaptions' className='carousel slide' data-bs-ride='carousel'>
          <div className='carousel-indicators'>
            <button
              type='button'
              data-bs-target='#carouselExampleCaptions'
              data-bs-slide-to='0'
              className='active'
              aria-current='true'
              aria-label='Review 1'></button>
            {/* <button
              type='button'
              data-bs-target='#carouselExampleCaptions'
              data-bs-slide-to='1'
              aria-label='Review 2'></button>
            <button
              type='button'
              data-bs-target='#carouselExampleCaptions'
              data-bs-slide-to='2'
              aria-label='Review 3'></button> */}
          </div>
          <div className='carousel-inner pb-5'>
            <div className='carousel-item active'>
              <h5>vikiaws.tech (2022)</h5>
              <p>"Awesome Work 🔥. Thanks @iamcatraz"</p>
            </div>
            {/* <div className='carousel-item'>
              <h5>Youtube (2022)</h5>
              <p>"The best customer service and great looking website"</p>
            </div>
            <div className='carousel-item'>
              <h5>Amazon (2022)</h5>
              <p>"The best customer service and great looking website"</p>
            </div> */}
          </div>
          <button
            className='carousel-control-prev'
            type='button'
            data-bs-target='#carouselExampleCaptions'
            data-bs-slide='prev'>
            <span className='carousel-control-prev-icon' aria-hidden='true'></span>
            <span className='visually-hidden'>Previous</span>
          </button>
          <button
            className='carousel-control-next'
            type='button'
            data-bs-target='#carouselExampleCaptions'
            data-bs-slide='next'>
            <span className='carousel-control-next-icon' aria-hidden='true'></span>
            <span className='visually-hidden'>Next</span>
          </button>
        </div>
      </div>
    </center>
  )
}

export default P_Home
